module.exports = __webpack_public_path__ + "static/img/download.27f95cf9.png";